<template>
  <div class="odwrap">
    <img
      :src="img"
      class="odimg"
      :class="{ hunodimg: hunbol }"
    />
    <div class="odmiddle">
      <div class="odmt twoline">{{ specName }}</div>
      <div class="odmb">冲印版数：{{ quantity }}</div>
    </div>
    <div class="odright omoney">
      <span class="f">{{ price | splitnum(0) }}</span
      >.{{ price | splitnum(1) }}
    </div>
  </div>
</template>
<script>
export default {
    name:'oditem',
    filters:{
        splitnum(val,index){
          return ((val/100).toFixed(2).split('.'))[index]
        }
    },
    props:{
      img:{
          type:String,
          default:'headImageUrl'
      },
      hunbol:{
          type:Boolean,
          default:false
      },
      specName:{
          type:String,
          default:''
      },
      quantity:{
          type:Number,
          default:1
      },
      price:{
          type:Number,
          default:0
      }
    }
};
</script>
<style lang="scss" scoped>
.odwrap {
  display: flex;
  .twoline {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .odimg {
    width: .52rem;
    height: .74rem;
    object-fit: contain;
    flex-shrink: 0;
    margin-right: .1rem;
  }
  .hunodimg {
    width: 1.13rem;
    height: .74rem;
  }
  .odmiddle {
    flex-grow: 1;
    overflow: hidden;
    .odmt {
      font-size: .14rem;
      color: #363636;
      font-weight: bold;
      margin-bottom: .08rem;
    }
    .odmb {
      font-size: .12rem;
      color: rgba(54, 54, 54, 0.5);
    }
  }
  .odright {
    flex-shrink: 0;
    margin-left: .10rem;
    font-size: .12rem;
    color: #363636;
    align-self: flex-end;
    margin-bottom: .21rem;
    &.omoney::before {
      display: inline-block;
      content: "￥";
      margin-right: .04rem;
    }
    .f {
      font-weight: bold;
      font-size: .18rem;
    }
  }
}
</style>